import { Box, Button, Stack } from "@mui/joy";
import Grid from "@mui/material/Grid2";

import React from "react";
import EmailIcon from "@mui/icons-material/Email";
import logo from "./../assets/image/LOGO 4.3.png";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PublicIcon from "@mui/icons-material/Public";
import { centrado } from "../utils/Estilos";
import { Typography } from "@mui/material";
import paypal from "./../assets/banner/marcas.png";
import PhoneIcon from "@mui/icons-material/Phone";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import MapIcon from "@mui/icons-material/Map";

const TikTokIcon = ({ color = "#000000", size = "20px" }) => {
  return (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width={size}
      height={size}
    >
      <path d="M41,4H9C6.243,4,4,6.243,4,9v32c0,2.757,2.243,5,5,5h32c2.757,0,5-2.243,5-5V9C46,6.243,43.757,4,41,4z M37.006,22.323 c-0.227,0.021-0.457,0.035-0.69,0.035c-2.623,0-4.928-1.349-6.269-3.388c0,5.349,0,11.435,0,11.537c0,4.709-3.818,8.527-8.527,8.527 s-8.527-3.818-8.527-8.527s3.818-8.527,8.527-8.527c0.178,0,0.352,0.016,0.527,0.027v4.202c-0.175-0.021-0.347-0.053-0.527-0.053 c-2.404,0-4.352,1.948-4.352,4.352s1.948,4.352,4.352,4.352s4.527-1.894,4.527-4.298c0-0.095,0.042-19.594,0.042-19.594h4.016 c0.378,3.591,3.277,6.425,6.901,6.685V22.323z" />
    </svg>
  );
};

const Redes = () => {
  return (
    <Box sx={{ color: "white" }}>
      <Typography variant="h6" textAlign="left" pl={1}>
        <strong>Redes Sociales</strong>
      </Typography>
      <Box pl={1}>
        <Box
          pt={1}
          onClick={() => window.open("https://www.instagram.com/publimed2/")}
        >
          <Stack direction={"row"} gap={1}>
            <InstagramIcon sx={{ fontSize: "24px" }} />
            <Typography fontWeight={"bold"}>Instagram</Typography>
          </Stack>
        </Box>
        <Box
          pt={1}
          onClick={() =>
            window.open("https://www.tiktok.com/@publimedpublimed")
          }
        >
          <Stack direction={"row"} gap={1}>
            <TikTokIcon color={"white"} size={"20px"} />
            <Typography fontWeight={"bold"}>Tiktok</Typography>
          </Stack>
        </Box>
        <Box
          pt={1}
          onClick={() =>
            window.open(
              "https://www.facebook.com/profile.php?id=100093661928867",
            )
          }
        >
          <Stack direction={"row"} gap={1}>
            <FacebookIcon sx={{ fontSize: "24px" }} />
            <Typography fontWeight={"bold"}>Facebook</Typography>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

const Contacto = () => {
  return (
    <Box sx={{ color: "white" }}>
      <Typography variant="h6" textAlign="left" pl={1}>
        <strong>Contacto</strong>
      </Typography>
      <Box pl={1}>
        <Box
          pt={1}
          onClick={() =>
            window.open(
              // "https://api.whatsapp.com/send?phone=593992083374&text=Hola%2C%20deseo%20informaci%C3%B3n%20sobre...",
"https://api.whatsapp.com/send?phone=593992083374&text=Hola%2C%20deseo%20informaci%C3%B3n%20sobre...",
            )
          }
        >
          <Stack direction={"row"} gap={1}>
            <WhatsAppIcon sx={{ fontSize: "24px" }} />
            <Typography fontWeight={"bold"}>Ventas +593992083374</Typography>
          </Stack>
        </Box>
        <Box pt={1} onClick={() => window.open("mailto:ventas@publimed.net")}>
          <Stack direction={"row"} gap={1}>
            <EmailIcon sx={{ fontSize: "24px" }} />
            <Typography fontWeight={"bold"}>ventas@publimed.net</Typography>
          </Stack>
        </Box>
        <Box pt={1}>
          <Stack direction={"row"} gap={1}>
            <BusinessCenterIcon sx={{ fontSize: "24px" }} />
            <Typography fontWeight={"bold"}>
              Propietario: Ángel España
            </Typography>
          </Stack>
        </Box>
        <Box pt={1}
        onClick={() =>
            window.open(
              // "https://api.whatsapp.com/send?phone=593992083374&text=Hola%2C%20deseo%20informaci%C3%B3n%20sobre...",
"https://api.whatsapp.com/send?phone=593992083374&text=Hola%2C%20deseo%20informaci%C3%B3n%20sobre...",
            )
          }>
          <Stack direction={"row"} gap={1}>
            <PhoneIcon sx={{ fontSize: "24px" }} />
            <Typography fontWeight={"bold"}>Soporte +593992083374</Typography>
          </Stack>
        </Box>
        <Box pt={1}>
          <Stack direction={"row"} gap={1}>
            <MapIcon sx={{ fontSize: "24px" }} />
            <Typography fontWeight={"bold"}>
              La Joya, Daule, Guayaquil, Ecuador.
            </Typography>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

const Policitas = () => {
  return (
    <Box sx={{ color: "white" }}>
      <Typography variant="h6" textAlign="left" pl={1}>
        <strong>Políticas y Condiciones</strong>
      </Typography>
      <Box pl={1} pt={1}>
        <Typography fontWeight="bold">
          <a
            href="/terms-conditions"
            target="_blank"
            style={{ color: "white" }}
          >
            Terms and Conditions
          </a>
        </Typography>
      </Box>
      <Box pl={1} pt={1}>
        <Typography fontWeight="bold">
          <a
            href="/refund-policy"
            target="_blank"
            style={{ color: "white" }}
          >
            Refund and Cancellation Policy
          </a>
        </Typography>
      </Box>
      <Box pl={1} pt={1}>
        <Typography fontWeight="bold">
          <a
            href="/privacy-policy"
            target="_blank"
            style={{ color: "white" }}
          >
            Privacy Policy
          </a>
        </Typography>
      </Box>
    </Box>
  );
};

export const Footer = () => {
  return (
    <Box
      display={"flex"}
      justifyContent={"space-around"}
      alignItems={"center"}
      sx={{
        padding: "20px 5px 20px 5px",
        background: "linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))",
      }}
    >
      <Grid container sx={{ width: "100%" }}>
        <Grid size={{ md: 3 }} sx={{ ...centrado, alignItems: "top" }}>
          <Redes />
        </Grid>
        {/* <Grid size={{ xs: 9, md: 0 }} /> */}
        <Grid size={{ md: 3 }} sx={{ ...centrado, alignItems: "top" }}>
          <Contacto />
        </Grid>
        <Grid size={{ md: 3 }} sx={{ ...centrado, alignItems: "top" }}>
          <Policitas />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ ...centrado }}>
          <Box>
            <img alt={"logoFooter"} src={paypal} height={"200px"} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
